/*
 * Data karty menu w kodowaniu systemu głównego.
 *
 * Publiczny katalog Main oddaje datę jako JEDNĄ LICZBĘ CAŁKOWITĄ w postaci
 * `rok * 100000 + miesiąc * 100 + dzień` — na przykład `202600820` to 20 sierpnia 2026.
 * To nie jest znacznik czasu ani liczba dni od epoki; potraktowanie jej jak `Date(202600820)`
 * daje 3 stycznia 1970 i wygląda przy tym całkiem wiarygodnie na ekranie.
 *
 * Ta liczba jest dowodem świeżości katalogu: mówi, z którego DNIA jest karta, którą przeczytaliśmy.
 * Bez niej klasyfikacja źródła musiałaby zostać „świeżość nieustalona".
 */

export function dekodujDateKarty(kod: number | null | undefined): string | null {
  if (typeof kod !== 'number' || !Number.isInteger(kod) || kod <= 0) return null;
  const rok = Math.floor(kod / 100_000);
  const reszta = kod % 100_000;
  const miesiac = Math.floor(reszta / 100);
  const dzien = reszta % 100;
  if (rok < 2000 || rok > 2200) return null;
  if (miesiac < 1 || miesiac > 12) return null;
  if (dzien < 1 || dzien > 31) return null;
  // Odrzucamy daty, których kalendarz nie zna (31 lutego) — inaczej ekran pokazałby datę
  // nieistniejącą i wyglądałaby ona równie wiarygodnie jak prawdziwa.
  const d = new Date(Date.UTC(rok, miesiac - 1, dzien));
  if (d.getUTCFullYear() !== rok || d.getUTCMonth() !== miesiac - 1 || d.getUTCDate() !== dzien) return null;
  return `${rok}-${String(miesiac).padStart(2, '0')}-${String(dzien).padStart(2, '0')}`;
}

/** Opis zbioru dat karty. Kilka dat naraz znaczy, że szkoły mają karty z różnych dni. */
export function opiszDatyKarty(kody: readonly number[] | null | undefined): string {
  if (!kody || kody.length === 0) return 'nieznana — źródło nie podało daty karty';
  const daty = kody.map(dekodujDateKarty).filter((d): d is string => d !== null).sort();
  if (daty.length === 0) return 'nieznana — data karty w nierozpoznanym formacie';
  if (daty.length === 1) return daty[0]!;
  return `${daty[0]} … ${daty[daty.length - 1]} (${daty.length} różnych dat)`;
}
